module.exports = __webpack_public_path__ + "img/5@2x.34413f6b.png";